import { render, staticRenderFns } from "./Mypage_dashbrd.vue?vue&type=template&id=774c1a22&"
import script from "./Mypage_dashbrd.vue?vue&type=script&lang=js&"
export * from "./Mypage_dashbrd.vue?vue&type=script&lang=js&"
import style0 from "./Mypage_dashbrd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports